// extracted by mini-css-extract-plugin
module.exports = {"container":"_1ezPOEKdpB","pagination":"_35xw_wZ7df","pagination-cell":"_2VmNhZo1uT","paginationCell":"_2VmNhZo1uT"};
    if(module.hot) {
      // 1614934693658
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  